/** This export is automatically generated */
export const gitHash = '11058eb2';
